<div class="card-base">
    <div class="card-content-login">



        <mat-progress-bar class="progress-margin login-container" color="primary" *ngIf="loading" mode="indeterminate">
        </mat-progress-bar>
        <form [formGroup]="loginForm" (ngSubmit)="login()">
            <mat-card class="card-container">
                <div class="card-content">
                    <mat-card-header>

                        <img class="image-login" src="../../../assets/images/clayer-login.png">

                    </mat-card-header>
                    <mat-card-title>
                        Iniciar sesión
                    </mat-card-title>
                    <mat-form-field class="full-width">
                        <input type="text" autocomplete="off" matInput placeholder="Usuario" formControlName="userName" autofocus required>
                        <mat-error *ngIf="f.userName.errors && f.userName.errors.required">
                            Introduce tu nombre de usuario
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="full-width">
                        <input type="password" autocomplete="off" matInput placeholder="Contraseña" formControlName="userPassword" required>
                        <mat-error *ngIf="f.userPassword.errors && f.userPassword.errors.required">
                            Introduce tu contraseña
                        </mat-error>
                    </mat-form-field>
                    <mat-error>
                        {{errorMessage}}
                    </mat-error>
                    <div style="text-align:right">
                        <button color="primary" mat-flat-button type="submit">SIGUIENTE</button>
                    </div>
                </div>
            </mat-card>
        </form>

    </div>
</div>
